import { z } from "zod";

export const Instance = z.object({
  id: z.string(),
  revision: z.number().int(),
  name: z.string(),
  created_at: z.number().int(),
  expires_at: z.number().int().nullable().optional(),
  users: z.array(
    z.object({
      id: z.string(),
      created_at: z.number().int(),
      active: z.boolean(),
      username: z.string(),
      first_name: z.string(),
      last_name: z.string(),
      role: z.enum(["standard", "guest", "admin"]),
    }),
  ),
});
